module.exports = __webpack_public_path__ + "static/media/compas-motives-bg.432d5cd4.png";